import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  meta?: ReactNode;
  /** "default" = signature 2px ink frame. "soft" = 1px hairline. "flush" = no padding. */
  variant?: "default" | "soft" | "flush";
}

export const Card = ({
  title,
  meta,
  variant = "default",
  className,
  children,
  ...rest
}: CardProps) => (
  <article
    className={cn(
      "hui-card",
      variant === "flush" && "hui-card--flush",
      variant === "soft" && "hui-card--soft",
      className
    )}
    {...rest}
  >
    {(title || meta) && (
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: "var(--space-3)",
        }}
      >
        {title && <div className="hui-card__title">{title}</div>}
        {meta && <span className="hui-card__meta">{meta}</span>}
      </header>
    )}
    {children}
  </article>
);
